export default __webpack_public_path__ + "static/media/support-mobile-ar.13dabdcb.svg";